<template>
  <div class="map-right-layers-item-service map-right-layers-item-service__container">
    <div
      class="map-right-layers-item-service__title"
    >
      <Checkbox
        v-model="isVisible"
        :binary="true"
        @click="toggleVisible"
      />
      <span
        class="map-right-layers-item-service__title__label"
        :title="props___.layer.getProperties().name"
      >
        {{ props___.layer.getProperties().name }}
      </span>
      <span
        class="
          material-icons
          map-right-layers-item-service__title__icon-trash
        "
        @click="deleteItem"
      >
        delete_outline
      </span>
    </div>
  </div>
</template>


<script setup>
// vue
import {ref, onUpdated} from 'vue';

// Primevue
import Checkbox from 'primevue/checkbox';

// #region Props, Emits
const props___ = defineProps({
  layer: {
    type: Object,
    default: null,
  },
});
const emits = defineEmits(['toggle-visible', 'click-delete']);
// #endregion


// #region Params, Ref, Reactives, Computed
const isVisible = ref(props___.layer.getVisible());
// #endregion


// #region Functions
function toggleVisible() {
  const visible = props___.layer.getVisible();
  props___.layer.setVisible(!visible);
  emits('toggle-visible');
}

function deleteItem() {
  emits('click-delete');
}
// #endregion


// #region Effects, Hooks
onUpdated(() => {
  isVisible.value = props___.layer.getVisible();
});
// #endregion


// #region Provide, Expose
// ...
// #endregion
</script>


<style lang="scss" scoped>
.map-right-layers-item-service {
  &__container {
    display: flex;
    flex-direction: column;
  }

  &__title {
    display: flex;
    align-items: center;

    &__icon-arrow {
      cursor: pointer;
    }

    &__label {
      flex: 1 1 100%;
      padding: 5px;
      display: block;
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    &__icon-trash {
      cursor: pointer;
      color: $brand__color--red;
    }
  }

}
</style>
